module.exports = "/content/9376921e4986999f8f7ce40f809726d6.png";